var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class:
        "jqac2-vld-wrapper text-wrapper " + (_vm.valid == false ? "error" : "")
    },
    [
      _vm.hint || _vm.required
        ? _c(
            "div",
            {
              staticClass: "validation-description",
              attrs: { "data-jqac2-validation-hint": "" }
            },
            [
              _c(
                "span",
                {
                  staticClass: "validation_tooltip",
                  staticStyle: { display: "none", opacity: "0", height: "60px" }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.hint) + "\n      "),
                  _vm.required == true
                    ? _c("div", [_vm._v("Pflichtfeld")])
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        class: "underline " + (_vm.valid == false ? "error" : ""),
        attrs: { type: "text", placeholder: _vm.label },
        domProps: { value: _vm.value }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }